// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"f231fba0","131":"9fb81933","309":"5e97feba","583":"74ecf0f3","685":"39293128","697":"0e248022","964":"ca231a4d"}[chunkId] + ".chunk.css";
};